/**
 * Brand logos live at the site root (`public/`). Paths are URL paths: `/filename.png`, etc.
 * Supports `.png`, `.webp`, `.jpg`, `.jpeg`, `.svg`.
 */
export type FeaturedPartnerCard = {
  logo: string;
  alt: string;
  role: string;
  description: string;
};

export type BrandLogo = {
  src: string;
  alt: string;
};

export const featuredPartnerCards: FeaturedPartnerCard[] = [
  {
    logo: "/brands/next.png",
    alt: "NEXT",
    role: "Nominated Vendor",
    description:
      "Providing premium packaging solutions for one of the UK's leading fashion retailers",
  },
  {
    logo: "/brands/silentnight.png",
    alt: "Silentnight",
    role: "Strategic Partner",
    description: "Supporting the UK's most trusted bedding brand with sustainable packaging",
  },
  {
    logo: "/brands/comfy.png",
    alt: "Comfy Quilts",
    role: "Long-term Client",
    description: "Delivering quality textile packaging for premium bedding products",
  },
];

/** Additional logos — files from `public/` (add or remove rows as you like) */
export const moreIndustryLeaderLogos: BrandLogo[] = [
  { src: "/tesco.svg", alt: "Tesco" },
  { src: "/dunelm.png", alt: "Dunelm" },
  { src: "/marksandspencer.jpg", alt: "Marks & Spencer" },
  { src: "/Debenhams.jpg", alt: "Debenhams" },
  { src: "/waitrose.jpg", alt: "Waitrose" },
  { src: "/lidl.png", alt: "Lidl" },
  { src: "/asda.png", alt: "Asda" },
  { src: "/Primark.jpg", alt: "Primark" },
  { src: "/casanova.png", alt: "Casanova" },
  { src: "/CatherineLansfield.png", alt: "Catherine Lansfield" },
  { src: "/kibek.jpg", alt: "Kibek" },
  { src: "/mio.png", alt: "Mio" },
  { src: "/tchibo.png", alt: "Tchibo" },
  { src: "/dorma.webp", alt: "Dorma" },
];
